import { Modal, Typography } from "@mui/material"
import React, { useEffect, useState } from "react"
import useStyles from "./useStylesAutenticateModal"
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined"

import GppBadOutlinedIcon from "@mui/icons-material/GppBadOutlined"
import { Box } from "@mui/system"
import CloseIcon from "@mui/icons-material/Close"

export default function AutenticateModal({
  loaderAutenticate,
  loaderFailure = true,
}) {
  const [open, setOpen] = useState(false)
  const classes = useStyles()

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  useEffect(() => {
    loaderAutenticate ? handleOpen() : handleClose()
  }, [loaderAutenticate])

  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      disableAutoFocus
      disableEnforceFocus
    >
      <Box className={classes.boxStyle}>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
          }}
        >
          <CloseIcon
            sx={{
              color: "#263057",
              cursor: "pointer",
              fontSize: 25,
            }}
            onClick={handleClose}
          />
        </div>
        <Box className={classes.boxStyle2}>
          {loaderFailure ? (
            <>
              <SecurityOutlinedIcon className={classes.badIcon} />
              <Typography className={classes.subtitle}>
                Lo sentimos, no tenés acceso a la Consola de Gestión Interna
              </Typography>
            </>
          ) : (
            <>
              <GppBadOutlinedIcon className={classes.errorIcon} />
              <Typography className={classes.subtitle}>
                Error al verificar. Inicie sesión nuevamente.
              </Typography>
            </>
          )}
        </Box>
      </Box>
    </Modal>
  )
}
